import { IDocumentMediaPreviewData } from "@home-health-notify/domain";
import { useContext } from "react";
import {
  ReferralFileItemButton,
  ReferralMediaIcon,
} from "../../../../addPatientGroup/AddPatientGroup.style";
import { DocumentMediaViewerContext } from "../../../../context/DocumentMediaViewerContext";
import {
  AttachmentType,
  FileInfo,
  ReferralFileText,
} from "./ReferralAttachment.style";
import ReferralAttachmentItemImage from "./ReferralAttachmentItemImage";

export const ReferralAttachmentItem = ({
  attachment,
  mediaList,
}: {
  attachment: IDocumentMediaPreviewData;
  mediaList: IDocumentMediaPreviewData[];
}) => {
  const { openDocumentMediaViewer } = useContext(DocumentMediaViewerContext);

  const openMediaDialog = (attachment: IDocumentMediaPreviewData) => {
    openDocumentMediaViewer(attachment, mediaList);
  };

  return (
    <ReferralFileItemButton
      data-testid="referral-item"
      onClick={() => openMediaDialog(attachment)}
    >
      <ReferralMediaIcon>
        <ReferralAttachmentItemImage
          type={attachment.type}
          url={attachment.media[0].url}
        />
      </ReferralMediaIcon>
      <FileInfo>
        <ReferralFileText data-testid="referral-file-text">
          {attachment.media[0].caption ?? attachment.mediaType}
        </ReferralFileText>
        <AttachmentType
          data-testid="referral-file-type"
          sx={{ fontSize: "small" }}
        >
          {attachment.type}
        </AttachmentType>
      </FileInfo>
    </ReferralFileItemButton>
  );
};
